var _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31757 0C5.68188 0 3.54484 2.08884 3.54484 4.6669C3.54484 7.24496 5.68188 9.33379 8.31757 9.33379C10.9532 9.33379 13.0903 7.24496 13.0903 4.6669C13.0903 2.08884 10.9532 0 8.31757 0Z",
    fill: "#8953C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0448 11.9995L5.59029 11.9995C2.95454 11.9995 0.817566 14.0893 0.817566 16.6683V20L15.8176 20V16.6683C15.8176 14.0893 13.6806 11.9995 11.0448 11.9995Z",
    fill: "#8953C4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8176,
    cy: 16,
    r: 6,
    fill: "#151929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9291 16.0252C19.9291 18.848 17.6297 21.1364 14.7933 21.1364C11.9568 21.1364 9.65741 18.848 9.65741 16.0252C9.65741 13.2024 11.9568 10.9141 14.7933 10.9141C17.6297 10.9141 19.9291 13.2024 19.9291 16.0252ZM14.1084 17.8701L12.2547 16.0253L14.1084 14.1804L14.5926 14.6623L13.5655 15.6845L17.19 15.6845L17.19 16.366L13.5654 16.366L14.5926 17.3882L14.1084 17.8701Z",
    fill: "#8953C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2981bb24c6e410fea0a93009774d4098.svg";
export { ForwardRef as ReactComponent };